import { Text, Icon } from '@artprov/design-system'

/**
 * Determina el color del indicador de estado
 * @param {string} estado - Estado del contrato ("Activo" | "Pendiente")
 * @returns {string} Clase de color de Tailwind
 */
const getEstadoColor = (estado) => {
  if (estado === 'Activo') return 'bg-green-500'
  if (estado === 'Pendiente') return 'bg-yellow-500'
  return 'bg-gray-400'
}

export function buildCuentasRows(data, { onEliminar } = {}) {
  if (!Array.isArray(data)) {
    return []
  }
  return data.map((item) => ({
    id: item.contrato,

    RAZON_SOCIAL: (
      <Text variant="body2" className="text-primary-10 truncate">
        {item.razonSocial}
      </Text>
    ),

    CUIT: (
      <Text variant="body2" className="text-primary-10">
        {item.cuit}
      </Text>
    ),

    CONTRATO: (
      <Text variant="body2" className="text-primary-10">
        {item.contrato}
      </Text>
    ),

    MEDICO: (
      <Text variant="body2" className="text-primary-10">
        {item.medico ? 'Sí' : 'No'}
      </Text>
    ),

    ESTADO: (
      <div className="flex items-center gap-2">
        <span className={`w-2.5 h-2.5 rounded-full ${getEstadoColor(item.estado)}`} />
        <Text variant="body2" className="text-primary-10">
          {item.estado}
        </Text>
      </div>
    ),

    acciones: onEliminar ? (
      <button
        onClick={() => onEliminar(item)}
        className="text-primary-10 hover:text-error-20 transition-colors"
        title="Eliminar cuenta"
        type="button"
      >
        <Icon icon="delete" size="small" />
      </button>
    ) : null,
  }))
}
